<template>
  <div id="app" v-cloak>
    <router-view/>
  </div>
</template> 
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { modules, store } from "./store";
import { banBackSpace } from './assets/js/preventBackspace.js'
export default {
  data() {
    return {};
  },
  watch: {
    curCompany: {
      handler() {
        if (!this.curCompany.isQlwVersion && store.state.inQlw) {
          this.selectB({
            isqlw: true
          });
        } else if (this.curCompany.isQlwVersion == null) {
          this.selectB({
            isqlw: false
          });
        }
        this.checkNoPermissions();
      },
      deep: true
    },
    loginUser() {
      this.checkNoPermissions();
    },
    authorizedInfo() {
      if (
        !this.authorizedInfo &&
        this.$route.path !== "/createFishery" &&
        this.$route.path !== "/switchingCompany"
      ) {
        this.$router.push({
          path: "unauthorized"
        });
      }
    }
  },
  methods: {
    ...mapActions(modules.user, ["selectB"]),
    checkNoPermissions() {
      if (!this.loginUser || this.loginUser.permissions != null) {
        return;
      }
      // 企联网版本走 QlwPermissions，LoginUser.permissions 为 null 属正常
      if (this.curCompany.isQlwVersion === true) {
        return;
      }
      const skipPaths = [
        "/login",
        "/createFishery",
        "/unauthorized",
        "/noPermissions",
        "/switchingCompany"
      ];
      if (skipPaths.some(path => this.$route.path.indexOf(path) !== -1)) {
        return;
      }
      this.$router.push({
        path: "noPermissions"
      });
    }
  },

  computed: {
    ...mapState(["loginUser", "curCompany", "authorizedInfo"])
  },
  created() {
    document.onkeypress=banBackSpace
    document.onkeydown=banBackSpace
  },
};
</script>

<style lang="stylus" scoped>
  [v-cloak]
    display: none;
</style>
